module.exports = __webpack_public_path__ + "img/40_38_031_240.5a264c32.jpg";